const utils = require('frontend-controller/lib/utils');
module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'propertiesForm',
    ],

    config: {
        projectMeta: {}, // @see MARK: CUSTOMER_PROJECT_META_LOADER
        contextClass: '',
        baseContextClass: '',
        entityContext: 'projects',
        preventClearOnCancel: true,
        // updateTabTitleForFieldCodes: {
        //     title: true
        // },
        // updateTabTitleTabContentLocator: '<< base_tabStrip_tabContent',
        grantedMinorChangesForFieldCodes: {},
        // heartbeatRefreshOn: {
        //     'reconnect': true,
        //     'resourceChanged.bo_projects': true,
        // },
    },

    methods: {
        // which properties is a customer allowed to change?
        onProjectMetaChanged(meta, nextMeta){
            if(
                this.config.isReady
                &&
                (!meta.hash || meta.hash !== nextMeta.hash)
            ){
                const grantedChanges = (nextMeta.grantedChanges || {}).project || {}
                if(!grantedChanges.major){
                    this.resetDirties()
                }
                this.refresh(!grantedChanges.major)
            }
        },

        // which properties is a customer allowed to change?
        onBeforeRender(){
            if(!this.config.creationMode){
                if(utils.isEmpty(this.model.projectMeta)){
                    this.locate('< templates_customers_projectTerms_controller', controller => {
                        this.model.projectMeta = {
                            ...(controller.model.projectMeta || {})
                        }
                    })
                }

                const grantedChanges = ((this.model.projectMeta || {}).grantedChanges || {}).project || {}

                for(const fieldCode in this.model.namedFields){
                    const field = this.model.namedFields[fieldCode] || {}
                    field.config = field.config || {}

                    if(field.config.disabledBackup === undefined && field.config.disabled !== undefined){
                        field.config.disabledBackup = !!field.config.disabled
                    }

                    if(grantedChanges.major || grantedChanges.minor && this.config.grantedMinorChangesForFieldCodes[fieldCode]){
                        field.config.disabled = !!field.config.disabledBackup
                    } else {
                        field.config.disabled = true
                    }
                }
            }
        },

        async placeOrderIfPossible(submitActionContext){
            let controller
            this.locate('< templates_customers_projectTerms_controller', c => controller = c)

            if(controller){
                await controller.editStatus('editStatus_project', undefined, 'order', undefined, undefined, submitActionContext)
            }
        },
        async onSubmitNothing(options = {}){
            if((options || {}).order){
                return this.placeOrderIfPossible()
            }
        },
        async customSubmit(body, options){
            options = options || {}

            let submitActionContext
            if(this.isDirty()){
                submitActionContext = await this.performAction(this.prepareAction('submit', undefined, undefined, {
                    source: {
                        submit: {
                            data: body
                        }
                    }
                }))
            }

            if(options.order) {
                await this.placeOrderIfPossible(submitActionContext)
            }

            return submitActionContext || {}
        },
    },

    hooks: {
        // which properties is a customer allowed to change?
        projectMetaChanged($element, options){
            const meta = { ...(this.model.projectMeta || {}) }
            const nextMeta = this.model.projectMeta = (options || {}).projectMeta || {}
            this.onProjectMetaChanged(meta, nextMeta)
        },
    },
}